var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center has-text-grey-light",class:("m-" + _vm.margin)},[_c('i',{staticClass:"far fa-lg fa-spinner fa-spin"})])}
var staticRenderFns = []

export { render, staticRenderFns }